export default "/images/watches_jewlleryLG.svg?bf345df59553ec21916a193a0078f673";